import { AxiosRestApplicationClient as MasterAgentGeneralDataAxiosRestApplicationClient } from '@g2-shared/api-client/generated/master-agent-general-data-app';
import { INotificationService, NotificationsService } from '@g2-shared/common';
import axios from 'axios';

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const MasterAgentGeneralDataApiClient = new MasterAgentGeneralDataAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  axios.create({ baseURL: VITE_APP_GATEWAY_BASE_URL, withCredentials: true })
);

interface DIContextInterface {
  NotificationService: () => INotificationService;
  MasterAgentGeneralDataApiClient: MasterAgentGeneralDataAxiosRestApplicationClient;
}

export const DIContext = (): DIContextInterface => ({
  NotificationService: NotificationsService,
  MasterAgentGeneralDataApiClient,
});
